"use strict";
// UAE mobile numbers: one clean format (+9715XXXXXXXX) — plan 5.5.
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeUaeMobile = normalizeUaeMobile;
exports.normalizeStaffMobile = normalizeStaffMobile;
exports.isPlaceholderPhone = isPlaceholderPhone;
const UAE_MOBILE = /^\+9715\d{8}$/;
/** Returns +9715XXXXXXXX, or null when the input is not a UAE mobile number. */
function normalizeUaeMobile(input) {
    let digits = input.replace(/[\s\-().]/g, '');
    if (digits.startsWith('+'))
        digits = digits.slice(1);
    else if (digits.startsWith('00'))
        digits = digits.slice(2);
    if (digits.startsWith('971'))
        digits = digits.slice(3);
    if (digits.startsWith('0'))
        digits = digits.slice(1);
    const result = `+971${digits}`;
    return UAE_MOBILE.test(result) ? result : null;
}
/**
 * Staff mobile: a UAE number (+9715XXXXXXXX), or a foreign number written with its
 * country code (+92 300 1234567 / 0092…) → +digits. Couriers and customers stay UAE only.
 */
function normalizeStaffMobile(input) {
    const uae = normalizeUaeMobile(input);
    if (uae)
        return uae;
    const v = input.replace(/[\s\-().]/g, '');
    const m = /^(?:\+|00)([1-9]\d{7,14})$/.exec(v);
    const digits = m?.[1];
    return digits && !digits.startsWith('971') ? `+${digits}` : null;
}
/**
 * Placeholder numbers (0500000000, 0555555555, 0501234567…) must never be
 * used to match consignees.
 */
function isPlaceholderPhone(normalized) {
    const local = normalized.replace(/^\+971/, '');
    const subscriber = local.slice(2); // after the 5X prefix
    if (/^(\d)\1+$/.test(subscriber))
        return true;
    if (/^(\d)\1+$/.test(local.slice(1)))
        return true;
    if (['1234567', '12345678', '87654321', '7654321'].some((seq) => subscriber.includes(seq)))
        return true;
    return false;
}
//# sourceMappingURL=phone.js.map